import { type GroupMessageItem, GroupMessageType } from '@/entities/feedbacks'
import dayjs from 'dayjs'

export const getItemKey = (entry: GroupMessageItem) => {
  if (entry.type === GroupMessageType.DATE) return `date-${entry.date}`
  if (entry.type === GroupMessageType.UNREAD) return GroupMessageType.UNREAD
  return entry.item.id
}

export const isLastMessageInGroup = (
  messages: GroupMessageItem[],
  index: number,
  entry: GroupMessageItem,
) => {
  const nextEntry = messages[index + 1]

  if (
    entry.type !== GroupMessageType.USER_MESSAGE ||
    !nextEntry ||
    nextEntry.type !== GroupMessageType.USER_MESSAGE
  ) {
    return true
  }

  if (
    dayjs(nextEntry.item.date).format('HH:mm') !==
      dayjs(entry.item.date).format('HH:mm') ||
    nextEntry.item.isCurrentUserMessage !== entry.item.isCurrentUserMessage
  ) {
    return true
  }

  return false
}
